import React from "react";

export default function RoomNumber(props) {
  return (
    <div className="chip-room-number-container">
      <div className="top-title-chip">Room number</div>
      <div className="room-number">{props.roomNumber}</div>
    </div>
  );
}
